<template>
    <div class="rp-order-address" v-if="addresses.length > 0">
        <div class="rp-order-address__header">
            {{$t('orderList.addressTitle')}}
        </div>
        <div class="rp-order-address__content">
            <div
                class="rp-order-address__content____item"
                v-for="(address, index) in addresses"
                :key="index+'addresses'"
                >
                <BillingImg v-if="address.type==='billing'"  />
                <ShippingImg v-if="address.type==='shipping'" />
                <div class="rp-order-address__content____item______content">
                    <div class="rp-order-address__content____item______content________title">
                        {{ address.title }}
                    </div>
                    <div class="rp-order-address__content____item______content________desc">
                        {{ address.address }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BillingImg from '../../Images/Billing';
import ShippingImg from '../../Images/Shipping';
export default {
    props: {
        orderData: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {};
    },

    components: {
        BillingImg,
        ShippingImg,
    },
    
    computed: {
        addresses() {
            let billingAddress = {
                title: this.$t('orderList.billingAddressTitle'),
                address: this.billingAddress,
                type: 'billing'
            }
            let shippingAddress = {
                title: this.$t('orderList.shippingAddressTitle'),
                address: this.shippingAddress,
                type: 'shipping'
            }
            let addresses = [];
            if(this.billingAddress)
                addresses.push(billingAddress)
            if( this.shippingAddress)
                addresses.push(shippingAddress)
            return addresses;
        },

        billingAddress() {
            let {
                billingAddressLine1,
                billingAddressLine2,
                billingCity,
                billingCountry,
                billingPostcode,
                billingState
            } = this.orderData;
            billingState = billingState ? billingState.toUpperCase() : billingState;
            billingCountry = billingCountry ? billingCountry.toUpperCase() : billingCountry;

            const values = [
                billingAddressLine1,
                billingAddressLine2,
                billingCity,
                billingState,
                billingCountry,
                billingPostcode,
            ].filter(value => !!(value && value.trim()))
            return values.join(', ')
        },

        shippingAddress() {
            let {
                shippingAddressLine1,
                shippingCity,
                shippingRegion,
                shippingPostcode,
                shippingCountry
            } = this.orderData
            shippingCountry = shippingCountry ? shippingCountry.toUpperCase() : shippingCountry;

            const values = [
                shippingAddressLine1,
                shippingCity,
                shippingRegion,
                shippingCountry,
                shippingPostcode,
            ].filter(value => !!(value && value.trim()))

            return values.join(', ')
        },
    },


}
</script>
<style lang="scss" scoped>
.rp-order-address {
    .rp-order-address__header {
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
        background: #f9f9f9;
        border-bottom: 1px solid #e6e6e6;
        padding: 15px 20px;
        font-size: 18px;
        color: #333333;
        font-weight: 400;
        line-height: 1;
        @include for-size(tablet-landscape-up) {
            padding: 20px 40px;
        }
        @include for-size(desktop-up){
            padding: $desktopPadding;
            font-size: 26px;
        }
    }
    .rp-order-address__content {
        padding: 20px;
        @include for-size(tablet-landscape-up) {
            padding: 30px 40px;
        }
        @include for-size(desktop-up){
           padding: 30px 60px;
        }
        .rp-order-address__content____item {
            +.rp-order-address__content____item {
                margin-top: 16px;
            }
            display: flex;
            margin-left: -3px;
            svg {
                min-height: 16px;
                max-height: 20px;
                min-width: 25px;
                max-height: 20px;
                margin-right: 10px;
                margin-top: 1px;
            }
            .rp-order-address__content____item______content {
                font-family: $chatFont;
                .rp-order-address__content____item______content________title {
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 1;
                    padding-bottom: 4px;
                    text-transform: uppercase;
                    @include for-size(desktop-up){
                        font-size: 20px;
                    }
                    color: #333;
                }
                .rp-order-address__content____item______content________desc {
                    font-size: 14px;
                    text-transform: capitalize;
                    @include for-size(desktop-up){
                        font-size: 18px;
                    }
                    color: #676767;
                }
            }
        }
    }
    
}
</style>